import styled from 'styled-components'

import { Typography } from 'components/Typography/Typography'
import { IconInfo } from 'components/Icons/InfoIcon'
import Slider from 'components/Slider/Slider'
import { Tooltip } from 'components/Tooltip/Tooltip'

const LeverageTitle = styled(Typography)`
  display: flex;
  align-items: center;
  // margin: 16px 0;
  margin-top: 32px;
  margin-bottom: 12px;
  margin-left: 0;
  margin-right: 0;
  & > div {
    display: flex;
    cursor: pointer;
    & > svg {
      margin-left: 6px;
      path {
        stroke: ${p => p.theme.colors.text.secondary};
      }
    }
  }
`

const LeverageValue = styled.div`
  border-radius: 8px;
  width: 80px;
  border: 1px solid ${p => p.theme.colors.border};
  padding: 16px;
  text-align: center;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    width: calc(100% - 32px);
  }
`

const SliderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    flex-direction: column;
    gap: 8px;
  }
`

interface Props {
  disabled: boolean
  labels: number[]
  leverage: number
  max?: number
  step: number
  handleLeverageChange: (newValue: number) => void
}

export const Leverage = ({ disabled, leverage, handleLeverageChange, max, step, labels }: Props) => {
  return (
    <div>
      <LeverageTitle variant="label2" color="secondary" fontWeight="medium">
        Leverage
        <Tooltip
          content="Multiply your position size by borrowing additional funds, increasing both potential gains and risks."
          position="top"
        >
          <IconInfo width={16} height={16} style={{ marginLeft: 6 }} />
        </Tooltip>
      </LeverageTitle>
      <SliderContainer>
        <Slider
          min={1}
          max={max}
          step={step}
          value={leverage}
          onChange={handleLeverageChange}
          labels={labels}
          disabled={disabled}
        />
        {!disabled && (
          <LeverageValue>
            <Typography variant="label1" fontWeight="bold">{`${leverage}x`}</Typography>
          </LeverageValue>
        )}
      </SliderContainer>
    </div>
  )
}
